import { IconProps } from "../../../types/style";

const GuidSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;

  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.16751 18.6653H14.8342V18.9237C14.8342 20.6195 13.455 21.9987 11.7592 21.9987H11.2433C9.54751 21.9987 8.16834 20.6195 8.16834 18.9237V18.6653H8.16751ZM19.0008 9.49868C19.0008 11.657 18.0692 13.7112 16.4442 15.1345C15.8283 15.6745 15.3817 16.312 15.1158 16.9987H7.80334C7.50501 16.2678 7.03167 15.5804 6.39084 14.9845C4.60001 13.317 3.75167 10.9595 4.06334 8.51702C4.49251 5.15035 7.25417 2.42952 10.6308 2.04785C12.77 1.80702 14.9058 2.48285 16.4958 3.90368C18.0875 5.32618 19.0008 7.36535 19.0008 9.49868ZM10.6675 10.3337C10.6675 10.7937 11.04 11.167 11.5008 11.167C11.9617 11.167 12.3342 10.7937 12.3342 10.3337V6.16702C12.3342 5.70702 11.9617 5.33368 11.5008 5.33368C11.04 5.33368 10.6675 5.70702 10.6675 6.16702V10.3337ZM12.7508 13.2504C12.7508 12.5604 12.1908 12.0004 11.5008 12.0004C10.8108 12.0004 10.2508 12.5604 10.2508 13.2504C10.2508 13.9404 10.8108 14.5004 11.5008 14.5004C12.1908 14.5004 12.7508 13.9404 12.7508 13.2504Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default GuidSVG;
